export default __webpack_public_path__ + "static/media/gm-pg-girl.56726c32.webp";